export default function Concept() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos">
          photography
        </a>
        {' > '}
        <a class="1" href="/photos/concept">
          concept
        </a>{' '}
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/concept/2sidesforthesameview.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/concept/2sidesforthesameview_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />2 Sides for the Same View{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a
                href="/assets/photo/concept/architecturalmadness.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/concept/architecturalmadness_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Architectural Madness{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/brokenlife.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/brokenlife_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Broken Life{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/conta.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/conta_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Conta
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/concept/donotcrosstheyellowline.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/concept/donotcrosstheyellowline_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Do Not Cross the Yellow Line{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/drowningcup.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/drowningcup_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Drowning Cup{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/emptyhead.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/emptyhead_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Empty Head{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/leftalone1.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/leftalone1_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Left Alone{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/leftalone2.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/leftalone2_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Left Alone{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/lembras-te.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/lembras-te_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                Lembras-te?
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a
                href="/assets/photo/concept/myimmaginaryfriend.jpg"
                target="_blank"
              >
                <img
                  src="/assets/photo/concept/myimmaginaryfriend_sm.jpg"
                  width="150"
                  height="200"
                />
                <br />
                My Immaginary Friend{' '}
              </a>{' '}
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/ontheline.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/ontheline_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                On the Line{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/soulfood.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/soulfood_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                Soul Food{' '}
              </a>
            </div>
          </td>
          <td>
            <div align="center">
              <a href="/assets/photo/concept/whattochoose.jpg" target="_blank">
                <img
                  src="/assets/photo/concept/whattochoose_sm.jpg"
                  width="200"
                  height="150"
                />
                <br />
                What to Choose{' '}
              </a>
            </div>
          </td>
        </tr>
      </table>
      <p align="left">&nbsp;</p>
    </>
  );
}
